import { useStore } from '@/store/DefaultStore.js';
import EventBus from '@/utilities/EventBus';

const urls = {
    //DEV: 'http://192.168.100.4:80/api/',
    DEV: 'http://localhost:80/api/',
    STG: 'https://api.stg.freesoft.com.mx/api/',
    QA: 'https://api.qa.freesoft.com.mx/api/',
    PRD: 'https://api.lativo.com.mx/api/'
}

function HandleError(data, status) {
    if (data.error_code === 'REQUIRES_LOGIN') {
        EventBus.$emit('RedirectToLogin');
    }

    const error = new Error(data.message);
    if (data.error_code) error.error_code = data.error_code;
    // Backend flags for uncontrolled exceptions: `unhandled` tells the client to
    // surface the error as a toast; `error_id` is a future correlation id.
    if (data.unhandled) error.unhandled = true;
    if (data.error_id) error.error_id = data.error_id;
    error.status = status;
    throw error;
}

// Re-throw errors already classified by HandleError untouched (so `status`,
// `unhandled`, `error_id` and `error_code` survive); only wrap raw network
// failures, which carry none of these.
function RethrowRequestError(error) {
    if (error && (error.status || error.error_code || error.unhandled)) {
        throw error;
    }
    throw new Error(error.message);
}

async function Post(url, data = {}){
    const store = useStore();

    let baseUrl = urls[process.env.VUE_APP_ENV];
    url = baseUrl + url;

    let headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    if(store.CurrentOrganizationPK != null){
        headers['OrganizationID'] = store.CurrentOrganizationPK;
    }

    url += '?' + new URLSearchParams(data).toString();

    return fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'include',
        headers: headers
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => HandleError(data, response.status));
        }
        return response.json();
    })
    .catch(RethrowRequestError);
}

async function Get(url, data = {}){
    const store = useStore();

    let baseUrl = urls[process.env.VUE_APP_ENV];
    url = baseUrl + url;

    url += '?' + new URLSearchParams(data).toString();

    let headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    if(store.CurrentOrganizationPK != null) {
        headers['OrganizationID'] = store.CurrentOrganizationPK;
    }

    return fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: 'include',
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => HandleError(data, response.status));
        }
        return response.json();
    })
    .catch(RethrowRequestError);
}

async function PostFormData(url, data = {}, files = []) {
    const store = useStore();

    let baseUrl = urls[process.env.VUE_APP_ENV];
    url = baseUrl + url;

    // Crea una instancia de FormData
    let formData = new FormData();

    // Agrega los datos al FormData
    Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
    });

    //Agrega los archivos al FormData
    for (let [key, value] of files.entries()) {
        formData.append(key, value);
    }

    let headers = {};
    // Si la organización actual está presente, agrégala
    if(store.CurrentOrganizationPK != null) {
        headers['OrganizationID'] = store.CurrentOrganizationPK;
    }

    return fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        headers: headers
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => HandleError(data, response.status));
        }
        return response.json();
    })
    .catch(RethrowRequestError);
}

export default {
    Post, Get, PostFormData
}
